import { useMemo } from "react";
import { getColorFromCssVariable } from "ui";
import { LineChartCard } from "../shared/LineChartCard";
import { CATEGORICAL_COLOR_VARIABLES } from "../shared/chartColors";
import { useDatadogQuery } from "../../DatadogAnalytics/useDatadogQuery";

type RateSeries = {
  label: string;
  data: number[];
}[];

type PaymentRateData = {
  labels: string[];
  series: RateSeries;
};

type PaymentRateChartProps = {
  title: string;
  description?: string;
  chartType:
    | "PROVIDERS_ACCEPTANCE_RATE"
    | "PROVIDERS_SUCCESS_RATE"
    | "PROVIDERS_CAPTURE_RATE"
    | "METHODS_ACCEPTANCE_RATE"
    | "METHODS_SUCCESS_RATE"
    | "METHODS_CAPTURE_RATE";
};

export function PaymentRateChart({
  title,
  description,
  chartType,
}: PaymentRateChartProps) {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<PaymentRateData>({ chartType });

  const colors = useMemo(
    () =>
      CATEGORICAL_COLOR_VARIABLES.map((variable) =>
        getColorFromCssVariable(variable)
      ),
    []
  );

  const datasets = useMemo(
    () =>
      (data?.series ?? []).map((item, index) => {
        const color = colors[index % colors.length];

        return {
          label: item.label,
          data: item.data,
          backgroundColor: color,
          borderColor: color,
        };
      }),
    [data, colors]
  );

  return (
    <LineChartCard
      ref={ref}
      title={title}
      description={description}
      format="percentage"
      labels={data?.labels ?? []}
      datasets={datasets}
      initialVisibleDatasets={5}
      queryStatus={queryStatus}
      error={error}
      retry={refetch}
    />
  );
}
